import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../../api/generated';
import { IWindowComponentProps } from '../../../../../../components/windows/WindowContext';
import { IUserEmail } from '../../GeneralSettingsPage';

interface UserWarningOfDevicesEmailCreateWindowProps {
    fetchData(): Promise<void>;
}

const UserWarningOfDevicesEmailCreateWindow: FC<IWindowComponentProps<UserWarningOfDevicesEmailCreateWindowProps>> = (props) => {
    const {
        componentProps: { fetchData },
        onClose
    } = props;

    const validationSchema = Yup.object<IUserEmail>().shape({
        email: Yup.string().required('Šis laukas yra privalomas').email('Neteisingas el. pašto formatas')
    });

    const initialState: IUserEmail = {
        id: 0,
        email: ''
    };

    const handleSubmit = async (values: IUserEmail, formikActions: formik.FormikHelpers<IUserEmail>) => {
        formikActions.setStatus();

        try {
            await api.administration.createUserWarningDevicesEmail(values);
            toast.success('El. paštas sėkmingai pridėtas');
            await fetchData();
            onClose();
        } catch (ex) {
            formikActions.setStatus(ex);
            toast.error(ex.error[0]);
        } finally {
            formikActions.setSubmitting(false);
        }
    };
    return (
        <formik.Formik
            validationSchema={validationSchema}
            initialValues={initialState}
            onSubmit={handleSubmit}
            render={(props) => (
                <formik.Form>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <formik.Field
                                name="email"
                                render={({ field, form }: formik.FieldProps<string>) => (
                                    <fabric.TextField
                                        {...field}
                                        label="El. paštas"
                                        placeholder="Įrašykite el. paštą"
                                        errorMessage={(props.status && props.status.email) || (form.errors.email && form.errors.email)}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                        <fabric.PrimaryButton
                            className="ms-slideRightIn40 ms-textAlignRight"
                            text="Išsaugoti"
                            disabled={props.isSubmitting || !props.isValid || !props.dirty}
                            type="submit"
                        />
                    </div>
                </formik.Form>
            )}
        />
    );
};

export default UserWarningOfDevicesEmailCreateWindow;
